import _ from 'lodash';

const state = {
    notifications: [],
    notificationsList: []
};

const mutations = {
    setNotifications: (state, payload) => {
        state.notifications = payload;
    },
    setNotificationsList: (state, payload) => {
        state.notificationsList = payload;
    },
    addNotification: (state, payload) => {
        state.notifications.unshift(payload);
    },
    removeNotification: (state, payload) => {
        var indexnot = state.notifications.map(item => item._id).indexOf(payload._id);
        state.notifications.splice(indexnot, 1);
    }
};

const getters = {
    /**getUsuarioData(state) {
        return state.usuarios[state.indexModal];
    },**/
};

const actions = {
    updateNotification: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            axios.get('/ajax/update_notification/'+payload.id_action).then((response) =>{
                commit('remove_notification', payload);
                resolve(true);
            });
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}